import { render } from "./DashboardFilter.vue?vue&type=template&id=3be4379c&scoped=true"
import script from "./DashboardFilter.vue?vue&type=script&lang=js"
export * from "./DashboardFilter.vue?vue&type=script&lang=js"

import "./DashboardFilter.vue?vue&type=style&index=0&id=3be4379c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be4379c"]])

export default __exports__